import {DataFetcher, PriorityConfig} from '@aboutyou/data-fetcher';
import {GetFilterResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/brand_hub/v1/service.types';
import React from 'react';
import {FilterAndSortFABView} from '../../../features/Filters/FilterAndSort/FilterAndSortFABView';
import {useBrandShopFilters} from '../utils/useBrandShopFilters';

interface BrandShopFilterButtonProps extends PriorityConfig {
  label: string;
}

export const BrandShopFilterButton: React.FC<BrandShopFilterButtonProps> = ({
  label,
  ...props
}) => (
  <DataFetcher
    request={useBrandShopFilters()}
    Error={null}
    View={FilterAndSortView}
    viewProps={{...props, label}}
    renderingPriority={props.renderingPriority}
  />
);

const FilterAndSortView: React.FC<GetFilterResponse & {label: string}> = ({
  appliedFiltersCount,
  label,
}) => {
  return <FilterAndSortFABView count={appliedFiltersCount} label={label} />;
};
